import SystemConfigurationDetail from './SystemConfigurationDetail';

function PasswordConfigComponent() {
  return <SystemConfigurationDetail mode="password" />;
}

export default PasswordConfigComponent;
